<div class="afffact-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a [routerLink]="['/utilisateur/espace/busnes/activite', safeName, accountNumber]" class="crumb-link">
        <i class="bi bi-arrow-left"></i> Retour activite business
      </a>
      <span class="crumb-current">Facturation</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Compte pro</p>
        <h1>{{bDescription}}</h1>
        <p class="lead">Paramétrez vos facturations mensuelles ou au clic et déclenchez les transferts.</p>
      </div>
      <div class="pill-row d-none d-sm-flex">
        <span class="pill pill-strong">Facturation</span>
        <span class="pill">Mensuel / Au clic</span>
      </div>
    </div>
    <div class="alerts">
      <p *ngIf="succes" class="alert-text success">La facturation a été modifiée avec succès.</p>
      <p *ngIf="error" class="alert-text danger">Impossible de modifier le type de facturation.</p>
      <p *ngIf="transfert" class="alert-text success">Transfert effectué.</p>
      <p *ngIf="notTranfering" class="alert-text danger">Solde insuffisant pour le transfert.</p>
      <p *ngIf="pay" class="alert-text success">Cette facture a déjà été payée.</p>
    </div>
  </div>

  <div class="card-glass p-3">
    <p class="eyebrow mb-1">Factures</p>
    <div
      class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-3">
      <h4 class="mb-0">Gestion des factures</h4>
      <div class="d-flex align-items-center gap-2 w-100 w-sm-auto">
        <label class="text-muted mb-0" for="monthSelectFactu">Mois</label>
        <select id="monthSelectFactu"
          class="form-select form-select-sm bg-dark text-light border-secondary w-100 w-sm-auto"
          [(ngModel)]="selectedMonth" (change)="applyMonthFilter(selectedMonth)">
          <option *ngFor="let m of monthOptions" [value]="m.value">{{ m.label | titlecase }}</option>
        </select>
      </div>
    </div>
    <!--<p class="text-muted small mb-3">Le mois en cours s’affiche en premier. Sélectionnez un mois précédent pour voir ses factures déjà chargées.</p>-->
    <div class="table-responsive">
      <table class="table table-borderless align-middle text-light">
        <thead>
          <tr>
            <th>Date</th>
            <th>Au mois</th>
            <th>Au clic</th>
            <th>Clic</th>
            <th>Total clic</th>
            <th>Modifier</th>
            <th>Transférer</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of facturations">
            <td>{{a.month}}/{{a.annee}}</td>
            <td>{{a.mensualite | currency:a.sigleMonnaie}}</td>
            <td>{{a.prixClick | currency:a.sigleMonnaie}}</td>
            <td>{{a.nclick}}</td>
            <td>{{a.totalPrix | currency:a.sigleMonnaie }}</td>
            <td>
              <div class="dropdown">
                <button class="btn btn-outline-light btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown">
                  Passer au
                </button>
                <div class="dropdown-menu">
                  <button class="dropdown-item" type="button" *ngIf="a.typ==1" (click)="changeTarif(a.id,2)">Au
                    mois</button>
                  <button class="dropdown-item" type="button" *ngIf="a.typ!=1" (click)="changeTarif(a.id,1)">Au
                    clic</button>
                </div>
              </div>
            </td>
            <td *ngIf="a.status; else notPaidTemplate">
              <i class="bi bi-check2-all" style="font-size: 12px; color: green;"></i>
            </td>
            <ng-template #notPaidTemplate>
              <td>
                <button type="button" class="btn btn-success btn-sm" (click)="makeTransfert(a.id)">
                  <i class="bi bi-arrow-clockwise me-1"></i>
                </button>
              </td>
            </ng-template>
          </tr>
          <tr *ngIf="!facturations || facturations.length === 0">
            <td colspan="7" class="text-center text-muted">Aucune facture disponible.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
